// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/mutation-connect-oauth2-client-credentials.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_Connection(
  $app_id: uuid!
  $connection_properties: jsonb!
  $location_id: uuid!
  $connection_id: uuid
) {
  apps_connect_oauth2_client_credentials(
    app_id: $app_id
    connection_properties: $connection_properties
    location_id: $location_id
    connection_id: $connection_id
  ) {
    connection_id
  }
}

`